import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Container, Nav } from 'react-bootstrap';
import './Navbar.css';

class NavbarComponent extends Component {
  render() {
    return (
      <Navbar bg="transparent" variant="dark" expand="md" className="mb-3 navbar-custom" aria-label="Main navigation">
        <Container>
          <Navbar.Brand as={Link} to="/">developer-behrens.com</Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar-nav" />
          <Navbar.Collapse id="main-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/about">Über mich</Nav.Link>
              <Nav.Link as={Link} to="/projects">Projekte</Nav.Link>
              <Nav.Link as={Link} to="/digimon">Digimon</Nav.Link>
              <Nav.Link as={Link} to="/pokemon">Pokémon</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default NavbarComponent;
